import { knowledgeModuleManifest } from '../knowledge.module.js';
import { knowledgeSettingRegistrations } from '../settings/knowledge-setting-definitions.js';
export const knowledgeWebModuleContribution = {
    moduleId: 'knowledge', manifest: knowledgeModuleManifest,
    settingRegistrations: knowledgeSettingRegistrations, settingEditors: [],
    hostContracts: [], hostContributions: [],
    routes: [{
            id: 'knowledge.web.library', moduleId: 'knowledge', path: '/knowledge',
            requiredPermission: 'knowledge.library.read',
            navigation: {
                id: 'knowledge.navigation.library', fallbackLabel: 'Company Library',
                labelConfigurationKey: 'knowledge.copy.library', labelValueProperty: 'navigationLabel', priority: 86,
            },
            load: () => import('./knowledge-library.page.js'),
        }, {
            id: 'knowledge.web.management', moduleId: 'knowledge', path: '/knowledge/manage',
            requiredPermission: 'knowledge.library.manage',
            navigation: {
                id: 'knowledge.navigation.management', fallbackLabel: 'Knowledge management',
                labelConfigurationKey: 'knowledge.copy.library', labelValueProperty: 'managementNavigationLabel', priority: 87,
            },
            load: () => import('./knowledge-management.page.js'),
        }, {
            id: 'knowledge.web.governance', moduleId: 'knowledge', path: '/knowledge/governance',
            requiredPermission: 'knowledge.governance.read',
            navigation: {
                id: 'knowledge.navigation.governance', fallbackLabel: 'Knowledge governance',
                labelConfigurationKey: 'knowledge.copy.governance', labelValueProperty: 'navigationLabel', priority: 88,
            },
            load: () => import('./knowledge-governance.page.js'),
        }],
};
export default knowledgeWebModuleContribution;
//# sourceMappingURL=knowledge-web.module-contribution.js.map